<template>
  <section class="section famtours" :class="{ '-blue': bg_color === 'blue' }">
    <div class="famtours__content">
      <h2 class="section__title" v-reveal>{{ title }}</h2>
      <div class="wysiwyg" v-html="description" v-reveal="{ delay: 200 }" />

      <a
        :href="btn_link"
        target="_self"
        class="button -right"
        :class="{ '-light': bg_color === 'blue' }"
        v-reveal="{ delay: 250 }"
      >
        {{ btn_text }}
        <div class="button__icon">
          <Icon id="arrow" />
        </div>
      </a>
    </div>

    <div class="famtours__images">
      <div
        v-for="(tour, key) in tours"
        :key="key"
        class="famtours__image"
        :style="{
          backgroundImage: `url(${tour.image.sm || tour.image.md || tour.image.original})`,
        }"
        v-reveal="{ delay: 75 * key + 1 }"
      >
        <div class="famtours__gradient">
          <p>{{ tour.destination }}</p>
          <p>{{ tour.dates }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'SectionFamtours',
  components: { Icon },
  props: {
    bg_color: {
      type: String,
      default: 'light',
    },
    images_side: {
      type: String,
      default: 'right',
    },
    title: {
      type: String,
      default: 'Nos voyages Famtours',
    },
    description: {
      type: String,
      default: `<p>L’heure de la rentrée a sonné et avec elle le retour tant attendu de nos Famtours! Sortez votre agenda et préparez votre valise, on reprend la route avec vous vers quatre de nos destinations les plus populaires : Toronto, Boston, Washington D.C. et New York!</p>
        <p> Voici en primeur les dates officielles de chacun des départs. Contactez-nous pour vous inscrire ou pour obtenir plus de détails. On a déjà hâte de vous revoir à bord!</p>
`,
    },
    btn_link: {
      type: String,
      default: '/',
    },
    btn_text: {
      type: String,
      default: 'Nous contacter',
    },
    tours: {
      type: Array,
      default: () => [
        {
          image: 'https://placehold.co/200x600',
          destination: 'Tonronto',
          dates: '1er au 5 octobre 2022',
        },
        {
          image: 'https://placehold.co/200x600',
          destination: 'Boston',
          dates: '1er au 5 octobre 2022',
        },
        {
          image: 'https://placehold.co/200x600',
          destination: 'Washington D.C.',
          dates: '1er au 5 octobre 2022',
        },
        {
          image: 'https://placehold.co/200x600',
          destination: 'New York',
          dates: '1er au 5 octobre 2022',
        },
      ],
    },
  },
}
</script>
